import { ERoutePaths } from "@gift/types";
import { Route } from "react-router-dom";
import { Page_TermsAndConditions } from "./TermsAndConditions";

export default [
    <Route
        path={ERoutePaths.TERMS_AND_CONDITIONS}
        element={<Page_TermsAndConditions />}
    />,
];
